import React from 'react';

import { DialogActions, Paragraph, TextButton } from '@zillow/constellation';

import type { Section } from '../../../models';
import { TENANT_PROTECTION } from '../../../constants';
import YesAndNo from '../../../components/Widgets/YesAndNo';
import InlineTooltip from '../../Widgets/InlineTooltip';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function TenantProtection({ section, setSectionValues }: Props) {
  function onNoTenantProtection(): void {
    setSectionValues({
      [TENANT_PROTECTION.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesTenantProtection(): void {
    setSectionValues({
      [TENANT_PROTECTION.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  return (
    <>
      <Paragraph fontType="h6" marginBottom="xs">
        Is the property covered by the{' '}
        <InlineTooltip
          shouldCloseOnOutsideClick={false}
          tooltipBodyText={
            <>
              AB 1482 caps annual rent increases at 5% plus the rate of inflation, and requires landlords to show a
              ”just cause” to evict tenants who have lived in your property for 12 months or more. Most housing located
              in the state of California is covered by AB 1482 unless it falls into one of the categories of exemptions.
              <DialogActions>
                <TextButton
                  as="a"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://sfrb.org/article/summary-ab-1482-california-tenant-protection-act-2019"
                >
                  Learn more
                </TextButton>
              </DialogActions>
            </>
          }
        >
          California Tenant Protection Act of 2019 (AB 1482)
        </InlineTooltip>
        ?
      </Paragraph>
      <YesAndNo
        yesHandler={onYesTenantProtection}
        noHandler={onNoTenantProtection}
        yesActive={section.getFieldValue(TENANT_PROTECTION.FIELD_NAME.IS_ENABLED)}
      />
    </>
  );
}

TenantProtection.description =
  'Asks whether or not the property is under AB 1482 (California Tenant Protection Act of 2019)';

export default TenantProtection;
